import { GroupAddOutlinedIcon } from 'opensolar-ui'
import React from 'react'
import { useHistory } from 'react-router-dom'
import SupplierIntegrationPricingLabel from './SupplierIntegrationPricingLabel'

type PriceOnApplicationPricingLabelProps = {
  variant?: 'default' | 'small'
}

const PriceOnApplicationPricingLabel: React.FC<PriceOnApplicationPricingLabelProps> = ({ variant = 'default' }) => {
  const history = useHistory()

  const handleLinkClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    history.push('/shop/cart')
  }

  return (
    <SupplierIntegrationPricingLabel
      variant={variant}
      labelText="Request price"
      icon={<GroupAddOutlinedIcon size={14} />}
      tooltipImageUrl={`${window.PUBLIC_URL}/images/indicative-pricing-tooltip.svg`}
      tooltipHeading="Request Price via Supplier Assist"
      tooltipBody="Confirm this item's trade price by requesting a quote through Supplier Assist. Access it via Shop or your Cart."
      tooltipLinkText="Take me there"
      onLinkClick={handleLinkClick}
    />
  )
}

export default PriceOnApplicationPricingLabel
